/* eslint-disable no-unreachable */
import React, { useState, useRef } from "react";
import useDragAndDrop from "./useDragAndDrop";
import Heading from "../Heading/Heading";
import "./DragDrop.scss";

export interface Props {
  initialText: any;
  subText?: any;
  icon?: any;
  errorButtonText: any;
  deleteButtonText: any;
  fileSizeErrorMsg: any;
  fileFormatErrorMsg: any;
  headingType?: any;
  sugHeadingType?: any;
  dragDropClass?: any;
  fileNameHeading?: any;
  iconClass?: any;
  fileType: any;
  maxFileSize:number
}

const DragDrop = ({
  initialText,
  subText,
  errorButtonText="X",
  deleteButtonText="delete",
  fileSizeErrorMsg,
  fileFormatErrorMsg,
  icon,
  headingType = "h2",
  sugHeadingType = "h6",
  dragDropClass,
  fileNameHeading = 'h2',
  iconClass,
  fileType,
  maxFileSize
}: Props) => {
  const {
    dragOver,
    setDragOver,
    onDragOver,
    onDragLeave,
    fileDropError,
    setFileDropError,
  } = useDragAndDrop();
  const [file, setFile] = useState<File | null>();
  const [fileURL, setFileURL] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const onDrop = (e: React.DragEvent<HTMLLabelElement>) => {
    e.preventDefault();
    setDragOver(false);
    const selectedFile = e?.dataTransfer?.files[0];
    if (selectedFile.type.split("/")[1] !== fileType) {
      return setFileDropError(fileFormatErrorMsg);
    }
    if (selectedFile.size > maxFileSize * 1000 * 1024) {
      return setFileDropError(fileSizeErrorMsg);
    }
    setFile(selectedFile);
    if (selectedFile) {
      setFile(selectedFile);
      setFileURL(URL.createObjectURL(selectedFile));
    }
  };

  const fileSelect = (e: any) => {
    let selectedFile = e.target.files[0] || e?.dataTransfer?.files[0];
    let file_size = e.target.files[0].size;
    console.log(selectedFile);
    
    if (selectedFile?.type.split("/")[1] !== fileType) {
      return setFileDropError(fileFormatErrorMsg);
    }
    if (file_size > maxFileSize * 1000 * 1024) {
      return setFileDropError(fileSizeErrorMsg);
    }
    setFile(selectedFile);
    setFileDropError("");
    if (selectedFile) {
      setFile(selectedFile);
      setFileURL(URL.createObjectURL(selectedFile));
    }
  };

  const clear = () => {
    setFile(null);
    setFileDropError(null);
    setDragOver(false);
    if (fileURL) {
      URL.revokeObjectURL(fileURL);
      setFileURL(null);
    }
  };

  return (
    <div
      className={`mfg-DragDrop${dragOver ? " draging" : ""}${
        dragDropClass ? " " + dragDropClass : ""
      }`}
    >
      <form>
        {fileDropError && (
          <span className="file-drop-error" role="alert">
            {fileDropError}
            <button onClick={clear}>{errorButtonText}</button>
          </span>
        )}
        <label
          htmlFor="file"
          onDragOver={onDragOver}
          onDragLeave={onDragLeave}
          onDrop={onDrop}
        >
          {file && (
            <div>
              <Heading
                    children={file.name}
                    Type={fileNameHeading}
                  ></Heading>
              <div className="file-properties">
                <ul>
                  <li>File Size - {Number(file.size /(1 * 1000 * 1024)).toFixed(2)}MB</li>
                  <li>File Type - {file.type}</li>
                  {(fileType === 'jpeg' || fileType === "png") && fileURL && <img src={fileURL} alt={file.name} style={{width:'100px', marginTop:'10px'}}/>}
                </ul>
              </div>
            </div>
          )}
          {!file && (
            <>
              {!dragOver ? (
                <>
                  {icon && <span className={iconClass}>{icon}</span>}
                  <Heading
                    children={initialText}
                    Type={headingType}
                  ></Heading>
                  {subText && (
                    <Heading children={subText} Type={sugHeadingType} />
                  )}
                </>
              ) : (
                "Drop here..."
              )}
            </>
          )}
        </label>
        <input type="file" name="file" id="file" onChange={fileSelect} />
        {file && <button onClick={clear}>{deleteButtonText}</button>}
      </form>
    </div>
  );
};

export default DragDrop;
